import { GlobalState } from 'store/types';

export const merchantProductStatisticsSelector = (state: GlobalState) => state.pages.merchantPage.productStats;
